import { createSlice } from '@reduxjs/toolkit';

export const RatingsSlice = createSlice({
  name: 'ratings',
  initialState: {
    devices_list: [],
    device: {},
    surveys_list: [],
    survey: {},
    assignments_list: [],
    assignment: {},
    qualifications_list: [],
    users_select_list: [],
    score_threshold: null,
    qualifications_stats: {
      mala: 0,
      regular: 0,
      buena: 0,
      'muy buena': 0,
      exelente: 0,
    },
    monthly_stats: [],
    monthly_metrics: [],
    has_discrepancie: false,
    completion_percentage: 0,
    nps: { score: 0, total: 0, promoters: 0, passives: 0, detractors: 0 },
    csat: { score: 0, total: 0, positive: 0, negative: 0 },
    ces: { score: 0, total: 0, sum: 0 },
    discrepancy_message: '',
    users_select_ratings_devices: [],
    available_configs: {
      devices: [],
      surveys: [],
    },
    alert_risk_level_trigger_log: null,
    rules_and_alerts_list: [],
    rules_and_alerts: {},
    available_users_for_alerts_select: [],
    resumen: null,
    areas_ratings_list: [],
    areas_list_select: [],
    area_rating: {},
    googleBusinessData: null,
    plantillas_respuestas_list: [],
    plantillas_categories_list: [],
    plantilla_respuesta: {},
    recurring_findings_list: [],
    areas_qualifications: [],
    follow_config_list: [],
    dinamic_texts_list: [],
    review_links_list: [] as any[],
    review_link: {},
    whatsapp_templates_list: [] as any[],
    whatsapp_template: {},
    google_bussinesses_list_for_select: [],
  },
  reducers: {
    setDevicesRedux: (state, { payload }) => {
      state.devices_list = payload;
    },
    storeDeviceRedux: (state, { payload }) => {
      state.device = payload;
    },
    setSurveysRedux: (state, { payload }) => {
      state.surveys_list = payload;
    },
    storeSurveyRedux: (state, { payload }) => {
      state.survey = payload;
    },
    setAssignmentsRedux: (state, { payload }) => {
      state.assignments_list = payload;
    },
    storeAssignmentRedux: (state, { payload }) => {
      state.assignment = payload;
    },
    setQualificationsRedux: (state, { payload }) => {
      state.qualifications_list = payload;
    },
    setUsersSelectListRedux: (state, { payload }) => {
      state.users_select_list = payload;
    },
    setStatsRedux: (state, { payload }) => {
      state.qualifications_stats = payload;
    },
    setMonthlyStatsRedux: (state, { payload }) => {
      state.monthly_stats = payload;
    },
    setMonthlyMetricsRedux: (state, { payload }) => {
      state.monthly_metrics = payload;
    },
    setHasDiscrepancieRedux: (state, { payload }) => {
      state.has_discrepancie = payload;
    },
    setCompletionPercentageRedux: (state, { payload }) => {
      state.completion_percentage = payload;
    },
    setNpsRedux: (state, { payload }) => {
      state.nps = payload;
    },
    setCsatRedux: (state, { payload }) => {
      state.csat = payload;
    },
    setCesRedux: (state, { payload }) => {
      state.ces = payload;
    },
    setDiscrepancyMessageRedux: (state, { payload }) => {
      state.discrepancy_message = payload;
    },
    setUsersListRatingsDevicesRedux: (state, { payload }) => {
      state.users_select_ratings_devices = payload;
    },
    setAvailableConfigsRedux: (state, { payload }) => {
      state.available_configs = payload;
    },
    setAlertRiskLevelTriggerLogRedux: (state, { payload }) => {
      state.alert_risk_level_trigger_log = payload;
    },
    setRulesAndAlertsListRedux: (state, { payload }) => {
      state.rules_and_alerts_list = payload;
    },
    setRulesAndAlertsRedux: (state, { payload }) => {
      state.rules_and_alerts = payload;
    },
    setAvailableUsersForAlertsRedux: (state, { payload }) => {
      state.available_users_for_alerts_select = payload;
    },
    setResumenRedux: (state, { payload }) => {
      state.resumen = payload;
    },
    setAreasRatingsListRedux: (state, { payload }) => {
      state.areas_ratings_list = payload;
    },
    setAreasListSelectListRedux: (state, { payload }) => {
      state.areas_list_select = payload;
    },
    setAreaRatingRedux: (state, { payload }) => {
      state.area_rating = payload;
    },
    setGoogleBusinessDataRedux: (state, { payload }) => {
      state.googleBusinessData = payload;
    },
    setPlantillasRedux: (state, { payload }) => {
      state.plantillas_respuestas_list = payload;
    },
    setPlantillasCategoriesRedux: (state, { payload }) => {
      state.plantillas_categories_list = payload;
    },
    storePlantillaRedux: (state, { payload }) => {
      state.plantilla_respuesta = payload;
    },
    setRecurringFindingsRedux: (state, { payload }) => {
      state.recurring_findings_list = payload;
    },
    setAreasQualifications: (state, { payload }) => {
      state.areas_qualifications = payload;
    },
    setQualificationsStats: (state, { payload }) => {
      state.qualifications_stats = payload;
    },
    setFollowConfigListRedux: (state, { payload }) => {
      state.follow_config_list = payload;
    },
    setScoreThresholdRedux: (state, { payload }) => {
      state.score_threshold = payload;
    },
    setDinamicTextsListRedux: (state, { payload }) => {
      state.dinamic_texts_list = payload;
    },
    setReviewLinksRedux: (state, { payload }) => {
      state.review_links_list = payload;
    },
    addOrUpdateReviewLinkRedux: (state, { payload }) => {
      const index = state.review_links_list.findIndex((link: any) => link.id === payload.id);
      if (index !== -1) {
        state.review_links_list[index] = payload;
      } else {
        state.review_links_list.push(payload);
      }
    },
    deleteReviewLinkRedux: (state, { payload }) => {
      state.review_links_list = state.review_links_list.filter((link: any) => link.id !== payload);
    },
    setWhatsappTemplatesRedux: (state, { payload }) => {
      state.whatsapp_templates_list = payload;
    },
    addOrUpdateWhatsappTemplateRedux: (state, { payload }) => {
      const index = state.whatsapp_templates_list.findIndex((item: any) => item.id === payload.id);
      if (index !== -1) {
        state.whatsapp_templates_list[index] = payload;
      } else {
        state.whatsapp_templates_list.push(payload);
      }
    },
    deleteWhatsappTemplateRedux: (state, { payload }) => {
      state.whatsapp_templates_list = state.whatsapp_templates_list.filter(
        (item: any) => item.id !== payload
      );
    },
    setGoogleBussinessesRedux: (state, { payload }) => {
      state.google_bussinesses_list_for_select = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setDevicesRedux,
  storeDeviceRedux,
  setSurveysRedux,
  storeSurveyRedux,
  setAssignmentsRedux,
  storeAssignmentRedux,
  setQualificationsRedux,
  setUsersSelectListRedux,
  setStatsRedux,
  setMonthlyStatsRedux,
  setMonthlyMetricsRedux,
  setHasDiscrepancieRedux,
  setCompletionPercentageRedux,
  setNpsRedux,
  setCsatRedux,
  setCesRedux,
  setDiscrepancyMessageRedux,
  setUsersListRatingsDevicesRedux,
  setAvailableConfigsRedux,
  setAlertRiskLevelTriggerLogRedux,
  setRulesAndAlertsListRedux,
  setRulesAndAlertsRedux,
  setAvailableUsersForAlertsRedux,
  setResumenRedux,
  setAreasRatingsListRedux,
  setAreasListSelectListRedux,
  setAreaRatingRedux,
  setGoogleBusinessDataRedux,
  setPlantillasRedux,
  setPlantillasCategoriesRedux,
  storePlantillaRedux,
  setRecurringFindingsRedux,
  setAreasQualifications,
  setQualificationsStats,
  setFollowConfigListRedux,
  setScoreThresholdRedux,
  setDinamicTextsListRedux,
  setReviewLinksRedux,
  addOrUpdateReviewLinkRedux,
  deleteReviewLinkRedux,
  setWhatsappTemplatesRedux,
  addOrUpdateWhatsappTemplateRedux,
  deleteWhatsappTemplateRedux,
  setGoogleBussinessesRedux,
} = RatingsSlice.actions;
